const transition = {
  timingShort: '.15s',
  timing: '.3s',
  timingLong: '.5s',
  animation: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
}

export default transition
